export default {"src":"/_next/static/media/video_grey.8734eea6.svg","height":14,"width":21};